module.exports = __webpack_public_path__ + "static/figurine_of_wondrous_power-78cecc4a891ed1f8275cb5badb7a05f9.jpeg";